import { render, staticRenderFns } from "./user_access.vue?vue&type=template&id=7e39d5e2&scoped=true&"
import script from "./user_access.vue?vue&type=script&lang=ts&"
export * from "./user_access.vue?vue&type=script&lang=ts&"
import style0 from "./user_access.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./user_access.vue?vue&type=style&index=1&id=7e39d5e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e39d5e2",
  null
  
)

export default component.exports